import { render, staticRenderFns } from "./tab_comment.vue?vue&type=template&id=02a4824d&scoped=true&"
import script from "./tab_comment.vue?vue&type=script&lang=js&"
export * from "./tab_comment.vue?vue&type=script&lang=js&"
import style0 from "./tab_comment.vue?vue&type=style&index=0&id=02a4824d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4824d",
  null
  
)

export default component.exports